import React, { useEffect, useRef, useState } from 'react'

const Loader = ({ loading }) => {
    const [progress, setProgress] = useState(0);
    const [finished, setFinished] = useState(false);
    const [visible, setVisible] = useState(false);
    const intervalRef = useRef(null);
    const hasStartedRef = useRef(false);
    const hideTimeoutRef = useRef(null);

    useEffect(() => {
        if (loading && !hasStartedRef.current) {
            hasStartedRef.current = true;
            startProgress();
        } else if (!loading && hasStartedRef.current) {
            finishProgress();
        }

        return () => {
            if (!loading) {
                clearInterval(intervalRef.current);
            }
        };
    }, [loading]);

    useEffect(() => () => {
        clearInterval(intervalRef.current);
        clearTimeout(hideTimeoutRef.current);
    }, []);

    const startProgress = () => {
        setProgress(0);
        setFinished(false);
        setVisible(true);

        intervalRef.current = setInterval(() => {
            setProgress((prev) => (prev < 90 ? prev + (100 - prev) * 0.1 : prev));
        }, 100);

    };

    const finishProgress = () => {
        clearInterval(intervalRef.current);
        setProgress(100);
        setFinished(true);

        hideTimeoutRef.current = setTimeout(() => {
            setVisible(false);
            setProgress(0)
            setFinished(true);
            hasStartedRef.current = false;
        }, 500);
    };

    // Render on the same pass that `loading` becomes true. Waiting for the
    // effect to set `visible` causes a blank frame when protected content is
    // removed while organization permissions are being refreshed.
    if (!visible && !loading) return null

    return (
        <div className='loader-container'>
            <div className='background' />
            <div className={`fill  ${finished ? 'finished' : ''}`}
                style={{ width: `${progress}%` }} />
        </div>
    )
}
export default Loader
